"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _context3, _context4, _context5;

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/slice");

var _Array$from = require("@babel/runtime-corejs3/core-js/array/from");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

var _Array$isArray = require("@babel/runtime-corejs3/core-js/array/is-array");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  usePrevious: true,
  useInterval: true,
  useTimeout: true,
  useDebounceState: true
};
exports.useTimeout = exports.usePrevious = exports.useInterval = exports.useDebounceState = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _react = require("react");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _useEventCallback = require("./use-event-callback");

_forEachInstanceProperty(_context3 = _Object$keys(_useEventCallback)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useEventCallback[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useEventCallback[key];
    }
  });
});

var _useCountdown = require("./use-countdown");

_forEachInstanceProperty(_context4 = _Object$keys(_useCountdown)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCountdown[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCountdown[key];
    }
  });
});

var _useUser = require("./use-user");

_forEachInstanceProperty(_context5 = _Object$keys(_useUser)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUser[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUser[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof _Symbol !== "undefined" && _getIteratorMethod(arr) || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (_Array$isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof _Symbol !== "undefined" && _getIteratorMethod(iter) != null || iter["@@iterator"] != null) return _Array$from(iter); }

function _arrayWithoutHoles(arr) { if (_Array$isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};

exports.usePrevious = usePrevious;

var useInterval = function useInterval(cb, ms) {
  var isRunOnInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var cbRef = (0, _react.useRef)();
  var timerRef = (0, _react.useRef)();

  var run = function run() {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = window.setInterval(function () {
      if (cbRef.current) {
        cbRef.current();
      }
    }, ms);
  };

  var stop = function stop() {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = undefined;
    }
  };

  (0, _react.useEffect)(function () {
    cbRef.current = cb;
  });
  (0, _react.useEffect)(function () {
    if (isRunOnInit) {
      run();
    }

    return stop;
  }, [ms]);
  return {
    run: run,
    stop: stop
  };
}; // NOTICE: useEffect is not depend on param ms, cause param cb just run once


exports.useInterval = useInterval;

var useTimeout = function useTimeout(cb, ms) {
  var cbRef = (0, _react.useRef)();
  var timerRef = (0, _react.useRef)();

  var run = function run() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(function () {
      if (cbRef.current) {
        cbRef.current();
        timerRef.current = undefined;
      }
    }, ms);
  };

  var stop = function stop() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  };

  (0, _react.useEffect)(function () {
    cbRef.current = cb;
  }, [cb]);
  (0, _react.useEffect)(function () {
    return stop;
  }, []);
  return {
    run: run,
    stop: stop
  };
};

exports.useTimeout = useTimeout;

var useDebounceFn = function useDebounceFn(fn) {
  var fnRef = (0, _react.useRef)(fn);
  fnRef.current = fn;

  for (var _len = arguments.length, debounceArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    debounceArgs[_key - 1] = arguments[_key];
  }

  var argsRef = (0, _react.useRef)(debounceArgs);
  var debouncedRef = (0, _react.useRef)();

  if (!debouncedRef.current) {
    var _context;

    debouncedRef.current = _debounce.default.apply(void 0, (0, _concat.default)(_context = [function () {
      fnRef.current.apply(fnRef, arguments);
    }]).call(_context, _toConsumableArray(argsRef.current)));
  } // 组件销毁前强制执行 debounced


  (0, _react.useEffect)(function () {
    return function () {
      var _debouncedRef$current;

      return (_debouncedRef$current = debouncedRef.current) === null || _debouncedRef$current === void 0 ? void 0 : _debouncedRef$current.flush();
    };
  }, []);
  return debouncedRef.current;
};

var useDebounceState = function useDebounceState(value, wait, options) {
  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      debounced = _useState2[0],
      setDebounced = _useState2[1];

  var update = useDebounceFn(function () {
    return setDebounced(value);
  }, wait, options);
  (0, _react.useEffect)(function () {
    update();
  }, [value]);
  return debounced;
};

exports.useDebounceState = useDebounceState;